module.exports = __webpack_public_path__ + "static/media/wcgPuffs.242d33b6.jpg";